import * as React from "react";
const SvgSort = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M8 9l4-4 4 4m0 6l-4 4-4-4" }));
export { SvgSort as ReactComponent };
